import { Button } from "@/components/ui/button";

/**
 * Consistent page header used across the app.
 * Props:
 *  - title, description
 *  - action: single button config {label, onClick, icon, testid}
 *  - actions: multiple actions (React nodes) as fallback
 */
export default function PageHeader({ title, description, action, actions, children }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 animate-fade-rise">
      <div className="min-w-0">
        <h1
          className="font-display font-bold text-3xl md:text-[32px] tracking-[-0.02em] leading-tight"
          data-testid="page-title"
        >
          {title}
        </h1>
        {description && (
          <p className="text-sm text-muted-foreground mt-2 max-w-2xl leading-relaxed">{description}</p>
        )}
      </div>
      <div className="flex flex-wrap gap-2 shrink-0">
        {children}
        {actions}
        {action && (
          <Button
            onClick={action.onClick}
            data-testid={action.testid}
            className="h-10 rounded-lg shadow-elev-2 active:scale-[0.98]"
          >
            {action.icon ? <action.icon className="w-4 h-4 mr-2" /> : null}
            {action.label}
          </Button>
        )}
      </div>
    </div>
  );
}
